import React, { useState } from 'react';
import {
  FiCheckCircle,
  FiCopy,
  FiDownload,
  FiUploadCloud
} from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import {
  exportStoredDraws,
  getDemoJsonStructure,
  mergeDrawsDelta
} from '../utils/drawStorage';

const downloadJson = (content, filename) => {
  const blob = new Blob([content], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
};

function AdminJsonUpload({ onDbUpdated, totalDraws }) {
  const [report, setReport] = useState(null);
  const [error, setError] = useState('');
  const [copied, setCopied] = useState(false);

  const handleFileUpload = (event) => {
    const file = event.target.files?.[0];
    event.target.value = '';

    if (!file) return;

    if (file.size > 5 * 1024 * 1024) {
      setError('Fișierul depășește limita locală de 5 MB.');
      setReport(null);
      return;
    }

    const reader = new FileReader();

    reader.onload = (loadEvent) => {
      try {
        const parsed = JSON.parse(loadEvent.target.result);
        const result = mergeDrawsDelta(parsed);

        setError('');
        setReport(result);
        onDbUpdated(result.total);
      } catch (uploadError) {
        setReport(null);
        setError(uploadError.message);
      }
    };

    reader.onerror = () => {
      setReport(null);
      setError('Fișierul nu a putut fi citit.');
    };

    reader.readAsText(file);
  };

  const copyDemo = async () => {
    try {
      await navigator.clipboard.writeText(getDemoJsonStructure());
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setError('Modelul nu a putut fi copiat automat.');
    }
  };

  return (
    <div className="admin-json-section">
      <div className="json-head">
        <div>
          <h4>BAZĂ EXTRAGERI ({totalDraws} ÎNREGISTRATE)</h4>
          <p>
            Import atomic: dacă o înregistrare este invalidă, fișierul nu este salvat.
          </p>
        </div>

        <div className="demo-actions">
          <button type="button" onClick={copyDemo} className="btn-secondary-sm">
            <SafeIcon icon={copied ? FiCheckCircle : FiCopy} />
            {copied ? 'COPIAT!' : 'COPIAZĂ MODEL'}
          </button>

          <button
            type="button"
            onClick={() => downloadJson(
              getDemoJsonStructure(),
              'loto649-model-import.json'
            )}
            className="btn-secondary-sm"
          >
            <SafeIcon icon={FiDownload} />
            MODEL JSON
          </button>

          <button
            type="button"
            onClick={() => downloadJson(
              exportStoredDraws(),
              `loto649-backup-${new Date().toISOString().slice(0, 10)}.json`
            )}
            className="btn-secondary-sm"
          >
            <SafeIcon icon={FiDownload} />
            BACKUP
          </button>
        </div>
      </div>

      <label className="upload-dropzone">
        <SafeIcon icon={FiUploadCloud} />
        <span>
          Click sau trage fișierul <strong>.json</strong> aici
        </span>
        <small>
          Exact 6 numere unice între 1–49, dată YYYY-MM-DD, maximum 5 MB.
        </small>
        <input
          type="file"
          accept=".json,application/json"
          onChange={handleFileUpload}
        />
      </label>

      {error && (
        <div className="delta-report import-error" role="alert">
          <strong>Import anulat:</strong> {error}
        </div>
      )}

      {report && (
        <div className="delta-report" role="status">
          <strong>✓ Import validat și finalizat:</strong>
          <ul>
            <li>{report.receivedCount} înregistrări verificate</li>
            <li>+{report.addedCount} extrageri noi</li>
            <li>~{report.updatedCount} extrageri actualizate</li>
            <li>={report.skippedCount} extrageri identice ignorate</li>
          </ul>
        </div>
      )}
    </div>
  );
}

export default AdminJsonUpload;